import { Camera, ChartLineUp, CreditCard, Files, Hammer, HouseLine, ListChecks, NotePencil, Package, Ruler, SquaresFour } from '@phosphor-icons/react';

// Keep this order aligned with the numeric JobDetail panels and existing URL tab keys.
export const jobSections = [
  { key: 'overview', title: 'Job Overview', icon: SquaresFour },
  { key: 'tasks', title: 'Tasks', icon: ListChecks },
  { key: 'work-orders', title: 'Work Orders', icon: Hammer },
  { key: 'photos', title: 'Photos', icon: Camera },
  { key: 'documents', title: 'Documents', icon: Files },
  { key: 'billing', title: 'Billing', icon: CreditCard },
  { key: 'measurements', title: 'Measurements', icon: Ruler },
  { key: 'financials', title: 'Financials', icon: ChartLineUp },
  { key: 'material-orders', title: 'Material Orders', icon: Package },
  { key: 'homeowner', title: 'Homeowner Hub', icon: HouseLine },
  { key: 'change-orders', title: 'Change Orders', icon: NotePencil },
];
